<template>
  <div>
    <h2 v-if="resources.length > 0">Ready-to-Use Resources</h2>
    <resource-preview-card
      v-for="resource in resources"
      :key="resource.uuid"
      v-bind="resource"/>
  </div>
</template>

<script>
import ResourcePreviewCard from '@/components/ResourcePreviewCard'

export default {
  name: 'StrategyResourceList',
  components: {
    ResourcePreviewCard
  },
  props: {
    resources: {
      type: Array,
      required: true
    }
  }
}
</script>

<style>
</style>
